import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBug } from "@fortawesome/free-solid-svg-icons";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    ListBugCardDevOpsController,
    SearchBugBoardColumnsDevOpsController,
} from "../../../../Controllers/DevOps/DevOpsController";
import { useUserInfor } from "../../../../Context/User";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";

export default function Boards() {
    const { UserInfor } = useUserInfor();

    const {
        value: lstSearchBugBoardColumnsDevOps,
        loading: lstSearchBugBoardColumnsDevOpsLoading,
    } = useAsyncEffect(() => SearchBugBoardColumnsDevOpsController(), []);

    const { value: lstBugCardDevOps, loading: lstBugCardDevOpsLoading } =
        useAsyncEffect(
            () =>
                ListBugCardDevOpsController({
                    idUsuario: UserInfor.ID_USUARIO ?? 0,
                    pageNumber: 1,
                    flAtivo: true,
                    itemsPerPage: 20,
                }),
            []
        );

    return (
        <div className="w-100">
            <div className="d-flex justify-content-center">
                {lstSearchBugBoardColumnsDevOpsLoading ||
                lstBugCardDevOpsLoading ? (
                    <Spinner color="primary" />
                ) : (
                    lstSearchBugBoardColumnsDevOps?.response.map(
                        (columnTitle, index) => {
                            const filteredItems = lstBugCardDevOps?.filter(
                                (item) =>
                                    item.devOpsCard?.dS_STATE?.toLocaleLowerCase() ===
                                    (columnTitle.toLocaleLowerCase() ?? "to do")
                            );

                            return (
                                <div
                                    key={columnTitle}
                                    className="d-flex flex-column bg-white rounded w-25 p-3 mr-5"
                                >
                                    <h6
                                        className="p-1 rounded"
                                        style={{
                                            borderRadius: "5px",
                                            alignSelf: "flex-start",
                                        }}
                                    >
                                        {columnTitle}
                                    </h6>
                                    {filteredItems?.map((item, index) => (
                                        <TaskCard
                                            key={
                                                item.devOpsCardCRMV2
                                                    .iD_DEVOPS_CARD
                                            }
                                            item={item}
                                            index={index}
                                        />
                                    ))}
                                </div>
                            );
                        }
                    )
                )}
            </div>
        </div>
    );
}

const TaskCard = ({ item, index }: any) => {
    return (
        <div className="card mt-5 d-flex flex-column shadow">
            <div className="m-4 flex-grow-1">
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon
                        icon={faBug}
                        className="text-danger mr-2 mb-0"
                    />
                    <p className="mb-0 mr-3">
                        {item.devOpsCardCRMV2.iD_DEVOPS_CARD}
                    </p>
                    <p className="font-weight-bold mt-1 mb-1">
                        {item.devOpsCard.dS_TITULO.substring(0, 30)}
                    </p>
                </div>
                <div className="d-flex align-items-center my-2">
                    <div
                        style={{
                            height: "8px",
                            width: "8px",
                            backgroundColor: "gray",
                            borderRadius: "50%",
                            marginRight: "5px",
                        }}
                    />
                    <p className="card-text">{item.devOpsCard.dS_STATE}</p>
                </div>
                <div className="d-flex align-items-center mb-2">
                    <img
                        className="rounded-circle mr-1"
                        style={{
                            height: "25px",
                            width: "25px",
                        }}
                        src={item.devOpsCard.dS_RESPONSAVEL.picture}
                        alt="imagem responsável"
                    />{" "}
                    {item.devOpsCard.dS_RESPONSAVEL.displayName}
                </div>
                <div className="d-flex justify-content-between">
                    <div>
                        {item.devOpsCard.dS_TIPO_ATIVIDADE
                            .split(";")
                            .map((activity: any, index: number) => (
                                <span
                                    key={index}
                                    className="badge bg-secondary my-1 mr-1"
                                >
                                    {activity.trim()}{" "}
                                </span>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
